"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const bluebird_1 = __importDefault(require("bluebird"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
const rendererData_1 = __importDefault(require("./rendererData"));
// eslint-disable-next-line no-redeclare
class MediaGroup extends complexData_1.default {
    getDocumentItemType(suffix = '') {
        return `Media${suffix}`;
    }
    static get allowedAssociations() {
        return {
            media: {
                key: 'media',
                instance: (0, modelLookup_1.complexFindModel)('Media'),
                cascadeDelete: false,
                condition: {
                    mediagroup_id: this.Entity.getFieldSymbols().id,
                },
            },
            documentItem: {
                key: 'documentItem',
                instance: (0, modelLookup_1.complexFindModel)('DocumentItem'),
                cascadeDelete: false,
                single: true,
                condition: {
                    linked_id: this.Entity.getFieldSymbols().id,
                    $or: [
                        { type: 'Media' },
                        { type: 'Media-l' },
                        { type: 'Media-m' },
                        { type: 'Media-fp' },
                    ],
                },
            },
            job: {
                key: 'job',
                instance: (0, modelLookup_1.complexFindModel)('Job'),
                cascadeDelete: false,
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().job_id,
                },
            },
            jobItem: {
                key: 'jobItem',
                instance: (0, modelLookup_1.complexFindModel)('JobItem'),
                cascadeDelete: false,
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().jobitem_id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            media: true,
        };
    }
    async getDocumentRenderData(L) {
        const documentItem = await this.getDocumentItem();
        const medias = await this.getAllMedia();
        const renderer = new rendererData_1.default(L, this, { medias, documentItemType: documentItem.data.type });
        return renderer.getDocumentTemplateData();
    }
    async isEveryMediaUploaded() {
        const mediaRecords = await this.getAllMedia();
        if (mediaRecords.length < 1) {
            return true;
        }
        return bluebird_1.default.reduce(mediaRecords, (result, mediaRecord) => (result ? mediaRecord.isUploaded() : false), true);
    }
}
MediaGroup.Entity = entity_1.default;
MediaGroup.modelProperties = modelProperties_1.default;
exports.default = MediaGroup;
//# sourceMappingURL=../../../../src/models/mediaGroup/index.js.map